import React, { useEffect, useState } from "react"

export default function HeroMask({ home }) {
  const [isFF, setIsFF] = useState(false)

  useEffect(() => {
    if (window.navigator.userAgent.match(/firefox|fxios/i)?.length > 0) {
      setIsFF(true)
    }
  }, [])

  // Ensure FF correctly paints the animation
  // Note: Duration must be >= CSS animation-duration
  const FFAnimationHelper = () => {
    return isFF ? (
      <animate
        attributeType="XML"
        attributeName="y"
        from="-0.001"
        to="0"
        dur="3s"
      />
    ) : null
  }

  // Homepage SVG masks (desktop and mobile)
  if (home) {
    return (
      <>
        {/* Mobile Mask */}
        <svg
          id={`hero-mask-home-mobile`}
          className="hero-mask util__fill util__tablet-down"
          width="0"
          height="0"
          fill="none"
          xmlns="http://www.w3.org/2000/svg"
        >
          <clipPath id={`heroMaskClipPath-home-mobile`}>
            <rect
              className="rect rect-timing-1 rect-height-86"
              width="15.16%"
              height="67%"
              fill="black"
            >
              <FFAnimationHelper />
            </rect>
            <rect
              className="rect rect-timing-2"
              x="16.967%"
              width="15.16%"
              height="78%"
              fill="black"
            >
              <FFAnimationHelper />
            </rect>
            <rect
              className="rect rect-timing-3 rect-height-83"
              x="33.935%"
              width="15.16%"
              height="64%"
              fill="black"
            >
              <FFAnimationHelper />
            </rect>
            <rect
              className="rect rect-timing-4 rect-height-73"
              x="50.902%"
              width="15.16%"
              height="73%"
              fill="black"
            >
              <FFAnimationHelper />
            </rect>
            <rect
              className="rect rect-timing-5 rect-height-88"
              x="67.870%"
              width="15.16%"
              height="100%"
              fill="black"
            >
              <FFAnimationHelper />
            </rect>
            <rect
              className="rect rect-timing-6 rect-height-78"
              x="84.837%"
              width="15.16%"
              height="76%"
              fill="black"
            >
              <FFAnimationHelper />
            </rect>
          </clipPath>
        </svg>

        {/* Desktop Mask */}
        <svg
          id={`hero-mask-home-desktop`}
          className="hero-mask util__fill util__tablet-up"
          width="0"
          height="0"
          fill="none"
          xmlns="http://www.w3.org/2000/svg"
        >
          <clipPath id={`heroMaskClipPath-home-desktop`}>
            <rect
              className="rect rect-timing-1 rect-height-90"
              width="5.22%"
              height="90%"
              fill="black"
            >
              <FFAnimationHelper />
            </rect>
            <rect
              className="rect rect-timing-2 rect-height-98"
              x="5.576%"
              width="5.22%"
              height="73%"
              fill="black"
            >
              <FFAnimationHelper />
            </rect>
            <rect
              className="rect rect-timing-3 rect-height-90"
              x="11.152%"
              width="5.22%"
              height="100%"
              fill="black"
            >
              <FFAnimationHelper />
            </rect>
            <rect
              className="rect rect-timing-4 rect-height-73"
              x="16.728%"
              width="5.22%"
              height="90%"
              fill="black"
            >
              <FFAnimationHelper />
            </rect>
            <rect
              className="rect rect-timing-5 rect-height-58"
              x="22.304%"
              width="5.22%"
              height="96%"
              fill="black"
            >
              <FFAnimationHelper />
            </rect>
            <rect
              className="rect rect-timing-6 rect-height-96"
              x="27.880%"
              width="5.22%"
              height="64%"
              fill="black"
            >
              <FFAnimationHelper />
            </rect>
            <rect
              className="rect rect-timing-1 rect-height-90"
              x="33.456%"
              width="5.22%"
              height="96%"
              fill="black"
            >
              <FFAnimationHelper />
            </rect>
            <rect
              className="rect rect-timing-2 rect-height-64"
              x="39.032%"
              width="5.22%"
              height="73%"
              fill="black"
            >
              <FFAnimationHelper />
            </rect>
            <rect
              className="rect rect-timing-3"
              x="44.609%"
              width="5.22%"
              height="93%"
              fill="black"
            >
              <FFAnimationHelper />
            </rect>
            <rect
              className="rect rect-timing-4 rect-height-93"
              x="50.185%"
              width="5.22%"
              height="100%"
              fill="black"
            >
              <FFAnimationHelper />
            </rect>
            <rect
              className="rect rect-timing-5 rect-height-73"
              x="55.761%"
              width="5.22%"
              height="64%"
              fill="black"
            >
              <FFAnimationHelper />
            </rect>
            <rect
              className="rect rect-timing-6 rect-height-96"
              x="61.337%"
              width="5.22%"
              height="90%"
              fill="black"
            >
              <FFAnimationHelper />
            </rect>
            <rect
              className="rect rect-timing-1 rect-height-64"
              x="66.913%"
              width="5.22%"
              height="96%"
              fill="black"
            >
              <FFAnimationHelper />
            </rect>
            <rect
              className="rect rect-timing-2 rect-height-96"
              x="72.489%"
              width="5.22%"
              height="58%"
              fill="black"
            >
              <FFAnimationHelper />
            </rect>
            <rect
              className="rect rect-timing-3 rect-height-90"
              x="78.065%"
              width="5.22%"
              height="73%"
              fill="black"
            >
              <FFAnimationHelper />
            </rect>
            <rect
              className="rect rect-timing-4"
              x="83.641%"
              width="5.22%"
              height="90%"
              fill="black"
            >
              <FFAnimationHelper />
            </rect>
            <rect
              className="rect rect-timing-5 rect-height-73"
              x="89.218%"
              width="5.22%"
              height="98%"
              fill="black"
            >
              <FFAnimationHelper />
            </rect>
            <rect
              className="rect rect-timing-6 rect-height-90"
              x="94.794%"
              width="5.22%"
              height="90%"
              fill="black"
            >
              <FFAnimationHelper />
            </rect>
          </clipPath>
        </svg>
      </>
    )
  }

  // Default SVG mask
  return (
    <svg
      id="hero-mask"
      className="hero-mask util__fill"
      width="0"
      height="0"
      xmlns="http://www.w3.org/2000/svg"
    >
      <clipPath id="heroMaskClipPath">
        <rect
          className="rect rect-timing-1"
          width="16.7%"
          height="100%"
          fill="black"
        >
          <FFAnimationHelper />
        </rect>
        <rect
          className="rect rect-timing-2"
          x="16.667%"
          width="16.7%"
          height="100%"
          fill="black"
        >
          <FFAnimationHelper />
        </rect>
        <rect
          className="rect rect-timing-3"
          x="33.333%"
          width="16.7%"
          height="100%"
          fill="black"
        >
          <FFAnimationHelper />
        </rect>
        <rect
          className="rect rect-timing-4"
          x="50%"
          width="16.7%"
          height="100%"
          fill="black"
        >
          <FFAnimationHelper />
        </rect>
        <rect
          className="rect rect-timing-5"
          x="66.667%"
          width="16.7%"
          height="100%"
          fill="black"
        >
          <FFAnimationHelper />
        </rect>
        <rect
          className="rect rect-timing-6"
          x="83.333%"
          width="16.7%"
          height="100%"
          fill="black"
        >
          <FFAnimationHelper />
        </rect>
      </clipPath>
    </svg>
  )
}
